import { gql } from '@/__generated__';

const TRIGGER_EXCEL_REPORT_EMAIL = gql(`#graphql
  mutation TriggerExcelReportEmail($deviceId: ID!, $start: Date!, $stop: Date!) {
    triggerExcelReportEmail(deviceId: $deviceId, start: $start, stop: $stop) {
      device {
        id
        profile {
          id
          name
        }
      }
      start
      stop
    }
  }
`);

export default TRIGGER_EXCEL_REPORT_EMAIL;
